import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { ReminderScheduleResponse } from '@/types/apps/reminder-schedule.type';

import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface ReminderScheduleGraphQLServiceInterface {
    getFields(): Record<string, any>;
    getEntityName(): string;
}

type ReminderScheduleListResponse = GqlListResponse<ReminderScheduleResponse>;

export class ReminderScheduleGraphQLService
    extends BaseService
    implements ReminderScheduleGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'reminderSchedule';
    }

    public getFields(): Record<string, any> {
        return {
            name: true,
            nextMaintenanceDate: true,
            lastMaintenanceDate: true,
            installationDate: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            device: {
                address: true,
                createdBy: true,
                createdDate: true,
                customerId: true,
                deletedAt: true,
                deletedBy: true,
                deviceGroupId: true,
                deviceModelId: true,
                deviceSKUId: true,
                deviceStatus: true,
                deviceTypeId: true,
                hasLoad: true,
                id: true,
                installationDate: true,
                isDeleted: true,
                latitude: true,
                loadingTime: true,
                longitude: true,
                machineRunningTime: true,
                modifiedBy: true,
                modifiedDate: true,
                name: true,
                note: true,
                operationTime: true,
                overload: true,
                pressure: true,
                processingSpeed: true,
                rfid: true,
                rotationSpeed: true,
                serialNumber: true,
                softWareVersion: true,
                supplier: true,
                temperature: true,
                timeUnit: true,
                totalHandledItems: true,
                usageTypeId: true,
                warrantyDay: true,
                warrantyPeriod: true,
            },
            deviceId: true,
            id: true,
            partDetailId: true,
            partDetail: {
                createdBy: true,
                createdDate: true,
                deletedAt: true,
                deletedBy: true,
                description: true,
                deviceId: true,
                id: true,
                installingQuantity: true,
                isDeleted: true,
                modifiedBy: true,
                modifiedDate: true,
                name: true,
                partCategoryId: true,
                partDetailStatus: true,
                partGroupId: true,
                partLifeTimeHours: true,
                partSKUId: true,
                partTypeId: true,
                quantity: true,
                receivedQuantity: true,
                removedQuantity: true,
                runningHoursAtInstallation: true,
                serialNumber: true,
                totalQuantity: true,
                usageTypeId: true,
            },
            reminderAdvanceDays: true,
            serialNumber: true,
            endDate: true,
            isDeleted: true,
            isFilterHead: true,
            maintenanceCycle: true,
            modifiedBy: true,
            modifiedDate: true,
            timestampId: true,
            type: true,
            unitMaintenanceCycle: true,
        };
    }

    public async index(query: string): Promise<ReminderScheduleListResponse> {
        return this.fetchGqlList(query, this.getEntityName());
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById()) {
            return {};
        }

        return {
            getFilterByRole: {
                inputType: 'input',
                key: 'device.customerId',
                operator: '=',
                value: this.getQueryById(),
            },
        };
    }
}
